export const recordExperimentView = (state, { id }) => ({
  ...state,
  viewedOnPage: state?.viewedOnPage?.length ? [...state?.viewedOnPage, id] : [id],
});
